<template>
  <div class="img-item">
    <div class="item-box">
      <a-tooltip v-if="item.img" placement="top" overlayClassName="preview-image-tooltip">
        <template #title>
          <img :src="item.img" style="width: 275px; height: 275px" />
        </template>
        <img :src="item.img" />
      </a-tooltip>
      <div v-else class="no-img-box" @click="uploadImage">
        <upload-outlined />
      </div>
      <template v-if="item.img">
        <a-space class="bottom">
          <a-tooltip placement="bottom">
            <template #title>上传图片</template>
            <upload-outlined @click="uploadImage" />
          </a-tooltip>
          <a-tooltip placement="bottom">
            <template #title>下载图片, 可以鼠标右击图片, 点击图片另存为</template>
            <download-outlined @click="downloadImage" />
          </a-tooltip>
          <a-tooltip v-if="showCropper" placement="bottom">
            <template #title>裁剪图片</template>
            <scissor-outlined @click="cropperImage" />
          </a-tooltip>
          <a-tooltip v-if="false && showImageInpainting" placement="bottom">
            <template #title>转换图片</template>
            <PictureOutlined @click="showUpdateImageModal"/>
          </a-tooltip>
          <a-tooltip placement="bottom">
            <template #title>预览图片</template>
            <scan-outlined @click="previewImage" />
          </a-tooltip>
          <a-tooltip v-if="showDeleteIcon" placement="bottom">
            <template #title>删除图片</template>
            <delete-outlined @click="deleteImage" />
          </a-tooltip>
        </a-space>
      </template>
    </div>
    <span v-if="!hideSize && item.width && item.height" class="size" :style="{color: item.width !== item.height && needMsg ? 'red' : 'inherit'}">
      <span v-if="item.width !== item.height && needMsg">
        {{ needMsg }}&nbsp;
      </span>
      {{ item.width + "px" }}*{{ item.height + "px" }}
    </span>
  </div>
  <a-modal v-model:visible="visible" class="header-fixed-modal" title="预览图片" width="1000px" style="top: 10px;">
    <div class="box" style="text-align:center">
      <img :src="item.img" style="max-width: 100%" />
    </div>
    <template #footer>
      <a-space>
        <a-button type="primary" @click="openPage">新窗口打开原图</a-button>
        <a-button type="primary" @click="copyImageUrl">复制图片地址</a-button>
        <a-button type="primary" danger @click="visible = false">关闭窗口</a-button>        
      </a-space>
    </template>
  </a-modal>
  <ImageInpainting1688 ref="imageInpainting1688" />
</template>
<script>
import {
  UploadOutlined,
  DownloadOutlined,
  ScissorOutlined,
  ScanOutlined,
  DeleteOutlined,
  PictureOutlined
} from "@ant-design/icons-vue"
import { CopyToClipboard, DownloadIamge } from '@/utils/co_utils'
import ImageInpainting1688 from '../image_inpainting_1688'
export default {
  components: {
    UploadOutlined,
    DownloadOutlined,
    ScissorOutlined,
    ScanOutlined,
    DeleteOutlined,
    PictureOutlined,
    ImageInpainting1688
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: Number,
    needMsg: String,
    hideSize: Boolean,
    showDeleteIcon: {
      type: Boolean,
      default: true
    },
    showImageInpainting: {
      type: Boolean,
      default: true
    },
    showCropper: {
      type: Boolean,
      default: true
    }
  },
  emits: ['upload', 'cropper', 'delete'],
  data() {
    return {
      visible: false
    }
  },
  methods: {
    uploadImage() {
      this.$emit("upload", { ...this.item, index: this.index })
    },
    cropperImage() {
      this.$emit("cropper", { ...this.item, index: this.index })
    },
    deleteImage() {
      this.$emit("delete", this.index)
    },
    previewImage() {
      this.visible = true
    },
    downloadImage() {
      this.$message.success('已下载图片, 可在浏览器下载记录里查看 ...')
      DownloadIamge(this.item.img)
    },
    copyImageUrl() {
      CopyToClipboard(this.item.img)
      this.$message.success('已成功复制图片链接')
    },
    openPage() {
      window.open(this.item.img)
    },
    showUpdateImageModal() {
      this.$refs.imageInpainting1688.visible = true
      this.$refs.imageInpainting1688.imgObj = this.item
    }
  }
}
</script>
<style scoped lang='less'>
  @import './index';
</style>
<style>
  .preview-image-tooltip {
    max-width: initial;
  }
</style>